import { render } from "./PhotoList.vue?vue&type=template&id=6b5af106&ts=true"
import script from "./PhotoList.vue?vue&type=script&lang=ts"
export * from "./PhotoList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__